import _ from 'lodash';

export const actionTypes = {
  ADD_SECTION: 'ADD_SECTION',
  MOVE_SECTION: 'MOVE_SECTION',
  DELETE_SECTION: 'DELETE_SECTION',
  UPDATE_SECTION_TITLE: 'UPDATE_SECTION_TITLE',
  UPDATE_SECTION_CONTENT: 'UPDATE_SECTION_CONTENT',
  RESET_CONTENT: 'RESET_CONTENT',
};

export const createEmptySection = () => ({
  title: '',
  content: {
    html: '',
    json: {},
  },
});

export default function reducer(state, action) {
  if (action.type === actionTypes.ADD_SECTION) {
    return addSection(state);
  }

  if (action.type === actionTypes.MOVE_SECTION) {
    return moveSection(state, action);
  }

  if (action.type === actionTypes.DELETE_SECTION) {
    return deleteSection(state, action);
  }

  if (action.type === actionTypes.UPDATE_SECTION_TITLE) {
    return updateSectionTitle(state, action);
  }

  if (action.type === actionTypes.UPDATE_SECTION_CONTENT) {
    return updateSectionContent(state, action);
  }

  if (action.type === actionTypes.RESET_CONTENT) {
    return resetContent(state, action);
  }

  return state;
}

function addSection(state) {
  const newState = _.cloneDeep(state);
  newState.push(createEmptySection());
  return newState;
}

function moveSection(state, action) {
  if (typeof action.sectionIndex !== 'number' || !action.direction) {
    console.error('sectionIndex and direction are required to move a section');
    return state;
  }

  const sectionToMove = state[action.sectionIndex];
  const newState = state.filter((_section, i) => i !== action.sectionIndex);
  const newSectionPosition = action.sectionIndex + (action.direction === 'up' ? -1 : 1);
  newState.splice(newSectionPosition, 0, sectionToMove);
  return newState;
}

function deleteSection(state, action) {
  if (typeof action.sectionIndex !== 'number') {
    console.error('sectionIndex is required to delete a section');
    return state;
  }

  return state.filter((_section, i) => i !== action.sectionIndex);
}

function updateSectionTitle(state, action) {
  if (typeof action.sectionIndex !== 'number') {
    console.error('sectionIndex is required to update a section title');
    return state;
  }

  if (action.sectionTitle === undefined) {
    console.error('sectionTitle is required to update a section title');
    return state;
  }

  const newState = _.cloneDeep(state);
  newState[action.sectionIndex].title = action.sectionTitle;
  return newState;
}

function updateSectionContent(state, action) {
  if (typeof action.sectionIndex !== 'number') {
    console.error('sectionIndex is required to update a section content');
    return state;
  }

  if (action.sectionContent === undefined) {
    console.error('sectionContent is required to update a section content');
    return state;
  }

  const newState = _.cloneDeep(state);
  newState[action.sectionIndex].content = action.sectionContent;
  return newState;
}

function resetContent(state, action) {
  if (!action.initialContent) {
    console.error('initialContent is required to reset the content');
    return state;
  }

  return action.initialContent;
}
